/**
 * 施設名の照合用正規化 (R6: 名称は揺れる)。
 *
 * 出力は照合キー専用で、表示には決して使わない (place-label.ts と同じ規約)。
 * NFKC では統一されない異体字 (靭⇔靱 など) を明示テーブルで吸収する。
 * 運用記録に実在した揺れ: 靭公園/靱公園、幸ケ谷/幸ヶ谷、總持寺/総持寺、開閉→開平 (誤字は対象外)。
 */

/** 異体字・表記揺れの正規化表 (キー → 正規形)。照合キー生成のみに使う。 */
const VARIANT_MAP: Record<string, string> = {
  靭: '靱',
  總: '総',
  ヶ: 'ケ',
  ノ: 'の',
  ツ: 'つ',
};

const VARIANT_RE = new RegExp(`[${Object.keys(VARIANT_MAP).join('')}]`, 'g');

/** 異体字・表記揺れだけをそろえる (VARIANT_MAP)。純関数・冪等。 */
export function normalizeVariants(s: string): string {
  return s.replace(VARIANT_RE, (ch) => VARIANT_MAP[ch] ?? ch);
}

/**
 * 施設名を照合キーへ正規化する。
 * NFKC + 小文字化 + 空白除去 + 括弧内注記除去 + 異体字統一。純関数・冪等。
 */
export function normalizeFacilityName(s: string): string {
  return s
    .normalize('NFKC')
    .toLowerCase()
    .replace(/\s/g, '')
    .replace(/[（(][^）)]*[）)]/g, '')
    .replace(VARIANT_RE, (ch) => VARIANT_MAP[ch] ?? ch);
}

/** 2つの施設名が照合上同一か。 */
export function sameFacilityName(a: string, b: string): boolean {
  const na = normalizeFacilityName(a);
  const nb = normalizeFacilityName(b);
  return na.length > 0 && na === nb;
}

/**
 * name と altNames をまとめた照合キー集合を作る。
 */
export function facilityNameKeys(name: string, altNames?: string[]): Set<string> {
  const keys = new Set<string>();
  const add = (s: string) => {
    const k = normalizeFacilityName(s);
    if (k) keys.add(k);
  };
  add(name);
  for (const alt of altNames ?? []) add(alt);
  return keys;
}
